import AuthService from '../services/AuthService';

// Helper to safely get current path
const getCurrentPath = () => {
    try {
        return window.location.pathname;
    } catch (e) {
        return "/unknown";
    }
};

const originalFetch = window.fetch;

window.fetch = async (input, init = {}) => {
    // Ensure headers object exists
    init.headers = init.headers || {};

    // Add X-Source-Page specific header for logging
    if (init.headers instanceof Headers) {
        init.headers.append('X-Source-Page', getCurrentPath());

        // Auto-inject Auth Token if available and missing
        const token = AuthService.getToken();
        if (token && !init.headers.has('Authorization')) {
            init.headers.append('Authorization', `Bearer ${token}`);
        }
    } else if (Array.isArray(init.headers)) {
        init.headers.push(['X-Source-Page', getCurrentPath()]);

        // Auto-inject Auth Token
        const token = AuthService.getToken();
        const hasAuth = init.headers.some(h => h[0] === 'Authorization');
        if (token && !hasAuth) {
            init.headers.push(['Authorization', `Bearer ${token}`]);
        }
    } else {
        // Plain object
        init.headers['X-Source-Page'] = getCurrentPath();

        // Auto-inject Auth Token
        const token = AuthService.getToken();
        if (token && !init.headers['Authorization']) {
            init.headers['Authorization'] = `Bearer ${token}`;
        }
    }

    // Call original fetch
    return originalFetch(input, init);
};

console.log("Global Fetch Interceptor Initialized: X-Source-Page enabled.");
